import { apiGet, apiPostGet, IPaginatedResponse } from '@/services/api.ts';
import { TMemo, TProject } from '@/types/models.ts';
import { TSuccessRes } from '@/app/products/api/endpoints.ts';
import { TLabelValue } from '@/types/misc.ts';

export async function getMemos(params: any) {
  return await apiGet<IPaginatedResponse<TMemo>>(`account/memos`, params);
}

export async function getProjects(params: any) {
  return await apiGet<IPaginatedResponse<any>>(`account/projects`, params);
}

export async function getProject(id: number) {
  return await apiGet<TProject>(`account/projects/${id}`);
}

export async function saveProject(data: any) {
  return await apiPostGet<TSuccessRes>(`account/projects`, data);
}

export async function saveProjectArea(data: any) {
  return await apiPostGet<TSuccessRes>(`account/projects/area`, data);
}

export async function sendMessage(data: any) {
  return await apiPostGet<TSuccessRes>(`account/send-message`, data);
}

export async function getTimezones() {
  return await apiGet<TLabelValue[]>(`timezones`);
}

export async function saveProfile(data: any) {
  return await apiPostGet<TSuccessRes>(`account/profile`, data);
}